export const moduleURI = {
	home: {
		key: 1,
		link: '/home',
	},
	user: {
		key: 2,
		link: '/user/search',
	},
	settings: {
		key: 3,
		link: '/setup_maintenance',
	},
	invoice: {
		key: 4,
		link: '/invoice/search',
	},
	delivery: {
		key: 5,
		link: '/delivery/search',
	},
	payment: {
		key: 6,
		link: '/payment/search',
	},
	acctReports: {
		key: 7,
		link: '/accounting_reports/generate',
	},
	drReports: {
		key: 8,
		link: '/dr_reports/generate',
	}
};

export const invoiceSearchLink = moduleURI.invoice.link;

export default moduleURI;